import React from "react"
import ToolbarMenu from "./toolbar-menu"

const Overlay = ({ onClick }) => (
  // It's okay for an overlay to have a click handler.
  // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
  <div
    onClick={onClick}
    style={{
      position: "fixed",
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      overflow: "auto"
    }}
  />
)

export default React.forwardRef(function Toolbar(
  { arrow, buttons = [], editor, menu, className, style, arrowStyle },
  ref
) {
  return (
    <>
      {menu.active && <Overlay onClick={menu.close} />}
      <div
        ref={ref}
        className={className}
        style={{
          background: menu.active ? "transparent" : undefined,
          ...style
        }}
      >
        <div style={{ opacity: menu.active ? 0 : 1 }}>
          {buttons.map((button, i) => {
            const ToolbarButton = button.component
            return (
              <ToolbarButton
                key={i}
                menu={{
                  close: menu.close,
                  open: () => menu.open(i)
                }}
              />
            )
          })}
        </div>
        <div>
          {menu.active && (
            <ToolbarMenu
              component={buttons[menu.index].menu}
              editor={editor}
              close={menu.close}
            />
          )}
        </div>
        {arrowStyle && (
          <div
            ref={arrow}
            style={{ left: arrowStyle.left || 0 }}
            className="selection-toolbar-arrow"
          />
        )}
      </div>
    </>
  )
})
